import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.map";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

function e(e, t) {
  document.dispatchEvent(new CustomEvent("track." + e, {
    detail: t
  }));
}

function t(t, n, r, o) {
  e("event", {
    category: t,
    action: n,
    label: r,
    value: o
  });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function n(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        u(r.next(e));
      } catch (e) {
        i(e);
      }
    }

    function c(e) {
      try {
        u(r["throw"](e));
      } catch (e) {
        i(e);
      }
    }

    function u(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(a, c);
    }

    u((r = r.apply(e, t || [])).next());
  });
}

function r(e, t) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: c(0),
    "throw": c(1),
    "return": c(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function c(i) {
    return function (c) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r["return"] : i[0] ? r["throw"] || ((o = r["return"]) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, c]);
    };
  }
}

function o(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
      o,
      i = n.call(e),
      a = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
      a.push(r.value);
    }
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i["return"]) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }

  return a;
}

function i() {
  for (var e = [], t = 0; t < arguments.length; t++) {
    e = e.concat(o(arguments[t]));
  }

  return e;
}

var a,
    c = (function (e, t) {
  t.defaults = {}, t.set = function (e, n, r) {
    var o = r || {},
        i = t.defaults,
        a = o.expires || i.expires,
        c = o.domain || i.domain,
        u = void 0 !== o.path ? o.path : void 0 !== i.path ? i.path : "/",
        l = void 0 !== o.secure ? o.secure : i.secure,
        s = void 0 !== o.httponly ? o.httponly : i.httponly,
        p = void 0 !== o.samesite ? o.samesite : i.samesite,
        d = a ? new Date("number" == typeof a ? new Date().getTime() + 864e5 * a : a) : 0;
    document.cookie = e.replace(/[^+#$&^`|]/g, encodeURIComponent).replace("(", "%28").replace(")", "%29") + "=" + n.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) + (d && d.getTime() >= 0 ? ";expires=" + d.toUTCString() : "") + (c ? ";domain=" + c : "") + (u ? ";path=" + u : "") + (l ? ";secure" : "") + (s ? ";httponly" : "") + (p ? ";samesite=" + p : "");
  }, t.get = function (e) {
    for (var t = document.cookie.split(";"); t.length;) {
      var n = t.pop(),
          r = n.indexOf("=");
      if (r = r < 0 ? n.length : r, decodeURIComponent(n.slice(0, r).replace(/^\s+/, "")) === e) return decodeURIComponent(n.slice(r + 1));
    }

    return null;
  }, t.erase = function (e, n) {
    t.set(e, "", {
      expires: -1,
      domain: n && n.domain,
      path: n && n.path,
      secure: 0,
      httponly: 0
    });
  }, t.all = function () {
    for (var e = {}, t = document.cookie.split(";"); t.length;) {
      var n = t.pop(),
          r = n.indexOf("=");
      r = r < 0 ? n.length : r, e[decodeURIComponent(n.slice(0, r).replace(/^\s+/, ""))] = decodeURIComponent(n.slice(r + 1));
    }

    return e;
  };
}(a = {
  exports: {}
}, a.exports), a.exports),
    u = (c.defaults, c.set, c.get);
c.erase, c.all;

function l(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r;) {
    e[o + n] = t[n];
  }

  return e;
}

var s = "object" == typeof global && global && global.Object === Object && global,
    p = "object" == typeof self && self && self.Object === Object && self,
    d = (s || p || Function("return this")()).Symbol,
    f = Object.prototype,
    v = f.hasOwnProperty,
    h = f.toString,
    w = d ? d.toStringTag : void 0;
var g = Object.prototype.toString;
var b = d ? d.toStringTag : void 0;

function y(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : b && b in Object(e) ? function (e) {
    var t = v.call(e, w),
        n = e[w];

    try {
      e[w] = void 0;
      var r = !0;
    } catch (e) {}

    var o = h.call(e);
    return r && (t ? e[w] = n : delete e[w]), o;
  }(e) : function (e) {
    return g.call(e);
  }(e);
}

function m(e) {
  return null != e && "object" == typeof e;
}

function k(e) {
  return m(e) && "[object Arguments]" == y(e);
}

var j = Object.prototype,
    U = j.hasOwnProperty,
    C = j.propertyIsEnumerable,
    E = k(function () {
  return arguments;
}()) ? k : function (e) {
  return m(e) && U.call(e, "callee") && !C.call(e, "callee");
},
    O = Array.isArray,
    I = d ? d.isConcatSpreadable : void 0;

function x(e) {
  return O(e) || E(e) || !!(I && e && e[I]);
}

function S(e) {
  return (null == e ? 0 : e.length) ? function e(t, n, r, o, i) {
    var a = -1,
        c = t.length;

    for (r || (r = x), i || (i = []); ++a < c;) {
      var u = t[a];
      n > 0 && r(u) ? n > 1 ? e(u, n - 1, r, o, i) : l(i, u) : o || (i[i.length] = u);
    }

    return i;
  }(e, 1) : [];
}

function T(e) {
  void 0 === e && (e = "q");
  var t = [];

  function n() {
    for (var e = [], n = 0; n < arguments.length; n++) {
      e[n] = arguments[n];
    }

    t.push(e);
  }

  return n[e] = t, n;
}

function q(e, t) {
  return n(this, void 0, void 0, function () {
    return r(this, function (n) {
      return [2, new Promise(function (n, r) {
        var o = document.createElement("script");
        o.src = e, o.async = !0, t && (o.crossOrigin = t), o.onload = n, o.onerror = r, document.head.appendChild(o);
      })];
    });
  });
}

var G = function G(e, t, n) {
  this.message = e, this.src = t, this.errorEvent = n;
};

function W(e, t, n) {
  return {
    scriptUrl: t + "/lib/a.js" + (!1 !== n ? "?z=" + Date.now() : ""),
    prepareQueue: function prepareQueue() {
      window.wa = T(), window.wa.e = t + "/collect", window.wa("set", "trackingId", e);
    },
    track: {
      pageview: function pageview(e) {
        var t = e.url;
        window.wa("track", {
          documentLocation: t,
          hitType: "pageview"
        });
      },
      event: function event(e) {
        var t = e.category,
            n = e.action,
            r = e.label,
            o = e.value;
        window.wa("track", {
          hitType: "event",
          eventCategory: t,
          eventAction: n,
          eventLabel: r,
          eventValue: o
        });
      }
    }
  };
}

function A(e) {
  return {
    scriptUrl: "https://www.google-analytics.com/analytics.js",
    hasImplicitConsent: !0,
    prepareQueue: function prepareQueue() {
      window.ga = T(), window.ga.l = Date.now(), window.ga("create", e, {
        siteSpeedSampleRate: 100,
        cookieExpires: 34187400
      });
    },
    toggleTracking: function toggleTracking(t) {
      window["ga-disable-" + e] = !t;
    },
    track: {
      pageview: function pageview(e) {
        var t = e.page;
        window.ga("set", "page", t), window.ga("send", "pageview");
      },
      event: function event(e) {
        var t = e.category,
            n = e.action,
            r = e.label,
            o = e.value;
        window.ga("send", "event", {
          eventCategory: t,
          eventAction: n,
          eventLabel: r,
          eventValue: o
        });
      }
    }
  };
}

function R(e) {
  return {
    scriptUrl: "https://static.hotjar.com/c/hotjar-" + e.hjid + ".js?sv=" + e.hjsv,
    prepareQueue: function prepareQueue() {
      window.hj = T(), window._hjSettings = e;
    }
  };
}

function z(e) {
  var t = e.appId,
      n = e.version;
  return {
    scriptUrl: "https://connect.facebook.net/" + (e.locale || "en_US") + "/fbevents.js",
    prepareQueue: function prepareQueue() {
      var e = function e() {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        e.callMethod ? e.callMethod.apply(e, t) : e.queue.push(t);
      };

      window.fbq = window._fbq = e.push = e, e.loaded = !0, e.version = n, e.queue = [], window.fbq("set", "autoConfig", !1, t), window.fbq("init", t);
    },
    track: {
      pageview: function pageview(e) {
        e.page;
        window.fbq("track", "PageView");
      }
    }
  };
}

function P(e) {
  return {
    scriptUrl: "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" + e + "/delighted.js",
    prepareQueue: function prepareQueue() {
      var e = ["survey", "reset", "config", "init", "set", "get", "event", "identify", "track", "page", "screen", "group", "alias"];
      if (!window.delighted) for (var t = function t(_t, n) {
        var r = e[n];
        _t[r] = _t[r] || function (e) {
          for (var n = [], r = 1; r < arguments.length; r++) {
            n[r - 1] = arguments[r];
          }

          var o = Array.prototype.slice.call(i([e], n));

          _t.push([e, o]);
        }, _t.SNIPPET_VERSION = "1.0.1";
      }, n = window.delighted = [], r = 0; r < e.length; r++) {
        t(n, r);
      }
    }
  };
}

function L(e) {
  var t = e.appId,
      n = e.userEmail;
  return {
    scriptUrl: "https://sc-static.net/scevent.min.js",
    prepareQueue: function prepareQueue() {
      var e = function e() {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        e.handleRequest ? e.handleRequest.apply(e, t) : e.queue.push(t);
      };

      window.snaptr = window._snaptr = e.push = e, e.queue = [];
      var r = n ? {
        user_email: n
      } : {};
      window.snaptr("init", t, r);
    },
    track: {
      pageview: function pageview(e) {
        e.page;
        window.snaptr("track", "PAGE_VIEW");
      }
    }
  };
}

function Q(e) {
  return n(this, void 0, void 0, function () {
    function t() {
      return n(this, void 0, void 0, function () {
        var e;
        return r(this, function (t) {
          switch (t.label) {
            case 0:
              return t.trys.push([0, 2,, 3]), [4, q(y.scriptUrl, "use-credentials")];

            case 1:
              return t.sent(), [3, 3];

            case 2:
              throw e = t.sent(), new G("Unable to load Wizbii Analytiks", y.scriptUrl, e);

            case 3:
              if (v && !u("uniqUserId")) throw new Error("'uniqUserId' cookie not set");
              return [2];
          }
        });
      });
    }

    function a(e) {
      return n(this, void 0, void 0, function () {
        var t, n, o, i, a, c, u, s, p;
        return r(this, function (r) {
          switch (r.label) {
            case 0:
              t = v.url, n = v.apiDomain, o = v.fullName, i = v.locale, a = v.productId, c = v.productLabel, u = v.enableTermsModal, s = v.labels, r.label = 1;

            case 1:
              return r.trys.push([1, 3,, 4]), [4, q(t, "anonymous")];

            case 2:
              return r.sent(), [3, 4];

            case 3:
              throw p = r.sent(), new G("Unable to load Consent Widget", t, p);

            case 4:
              return document.addEventListener("WizbiiGdpr.consentsChange", function (e) {
                e.WizbiiGdpr.consent.forEach(l);
              }), document.addEventListener("WizbiiGdpr.consentChange", function (e) {
                l(e.WizbiiGdpr.consent);
              }), window.WizbiiGdpr.init({
                locale: i,
                product: {
                  id: a,
                  label: c
                },
                apiDomain: n,
                fullName: o,
                enableTermsModal: u,
                managedConsents: Object.keys(w),
                customLabels: s,
                informationGroupKeys: b
              }), e && window.WizbiiGdpr.setAuth(e), [2];
          }
        });
      });
    }

    function c() {
      return n(this, void 0, void 0, function () {
        var e;
        return r(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, window.WizbiiGdpr.getConsents()];

            case 1:
              return e = t.sent(), S(Object.values(e)).filter(function (e) {
                return void 0 !== e.value;
              }).forEach(l), [2];
          }
        });
      });
    }

    function l(e) {
      var t = e.key,
          n = e.value,
          r = w[t],
          o = m.get(t);
      m.set(t, n), r.toggleTracking ? r.toggleTracking(n) : void 0 !== o && console.info("Consent change for '" + t + "' will take effect on next reload");
    }

    function s() {
      var e = this;
      return Object.entries(w).map(function (t) {
        var i = o(t, 2),
            a = i[0],
            c = i[1];
        return n(e, void 0, void 0, function () {
          return r(this, function (e) {
            switch (e.label) {
              case 0:
                if (!c.toggleTracking && !m.get(a)) return [2];
                e.label = 1;

              case 1:
                return e.trys.push([1, 3,, 4]), [4, q(c.scriptUrl)];

              case 2:
                return e.sent(), [3, 4];

              case 3:
                return e.sent(), console.warn("Unable to load tracker '" + a + "'"), [3, 4];

              case 4:
                return [2];
            }
          });
        });
      });
    }

    var p, d, f, v, h, w, g, b, y, m;
    return r(this, function (n) {
      switch (n.label) {
        case 0:
          return p = e.waApiUrl, d = e.waTrackingId, f = e.waBustCache, v = e.consentWidget, h = e.trackers, w = void 0 === h ? {} : h, g = e.informationGroupKeys, b = void 0 === g ? [] : g, i([y = W(d, p, f)], Object.values(w)).forEach(function (e) {
            e.prepareQueue(), Object.entries(e.track || {}).forEach(function (e) {
              var t = o(e, 2),
                  n = t[0],
                  r = t[1];
              document.addEventListener("track." + n, function (e) {
                var t = e.detail;
                r(t);
              });
            });
          }), m = new Map(Object.entries(w).map(function (e) {
            var t = o(e, 2);
            return [t[0], t[1].hasImplicitConsent || void 0];
          })), [4, t()];

        case 1:
          return n.sent(), v ? [4, a(v.auth)] : [3, 4];

        case 2:
          return n.sent(), [4, c()];

        case 3:
          n.sent(), n.label = 4;

        case 4:
          return [4, Promise.all(s())];

        case 5:
          return n.sent(), [2];
      }
    });
  });
}

export { G as LoadScriptException, T as buildCommandQueue, P as createDelightedConfig, z as createFacebookPixelConfig, A as createGoogleAnalyticsConfig, R as createHotjarConfig, L as createSnapchatPixelConfig, W as createWizbiiAnalyticsConfig, q as loadScript, Q as setupTracking, e as track, t as trackEvent };